/* tslint:disable */
/* eslint-disable */
/**
 * Oil refinery process modeling system
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.2.4
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import type {HTTPValidationError, ProfilerMode} from '../models/index';
import {
  HTTPValidationErrorFromJSON,
  HTTPValidationErrorToJSON,
  ProfilerModeFromJSON,
  ProfilerModeToJSON
} from '../models/index';

export interface DefaultIsAliveRequest {
  xProfilerMode?: ProfilerMode;
}

export interface DefaultIsReadyRequest {
  xProfilerMode?: ProfilerMode;
}

export interface DefaultMetricsRequest {
  xProfilerMode?: ProfilerMode;
}

/**
 *
 */
export class DefaultApi extends runtime.BaseAPI {
  /**
   * Is Alive
   */
  async defaultIsAliveRaw(
    requestParameters: DefaultIsAliveRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<object>> {
    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (requestParameters['xProfilerMode'] != null) {
      headerParameters['X-Profiler-Mode'] = String(requestParameters['xProfilerMode']);
    }

    const response = await this.request(
      {
        path: `/healthcheck`,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters
      },
      initOverrides
    );

    return new runtime.JSONApiResponse<any>(response);
  }

  /**
   * Is Alive
   */
  async defaultIsAlive(
    requestParameters: DefaultIsAliveRequest = {},
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<object> {
    const response = await this.defaultIsAliveRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Is Ready
   */
  async defaultIsReadyRaw(
    requestParameters: DefaultIsReadyRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<object>> {
    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (requestParameters['xProfilerMode'] != null) {
      headerParameters['X-Profiler-Mode'] = String(requestParameters['xProfilerMode']);
    }

    const response = await this.request(
      {
        path: `/ready`,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters
      },
      initOverrides
    );

    return new runtime.JSONApiResponse<any>(response);
  }

  /**
   * Is Ready
   */
  async defaultIsReady(
    requestParameters: DefaultIsReadyRequest = {},
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<object> {
    const response = await this.defaultIsReadyRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Metrics
   */
  async defaultMetricsRaw(
    requestParameters: DefaultMetricsRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<any>> {
    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (requestParameters['xProfilerMode'] != null) {
      headerParameters['X-Profiler-Mode'] = String(requestParameters['xProfilerMode']);
    }

    const response = await this.request(
      {
        path: `/metrics`,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters
      },
      initOverrides
    );

    if (this.isJsonMime(response.headers.get('content-type'))) {
      return new runtime.JSONApiResponse<any>(response);
    } else {
      return new runtime.TextApiResponse(response) as any;
    }
  }

  /**
   * Metrics
   */
  async defaultMetrics(
    requestParameters: DefaultMetricsRequest = {},
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<any> {
    const response = await this.defaultMetricsRaw(requestParameters, initOverrides);
    return await response.value();
  }
}
